<template>
  <div class="app-container">
    <CrudTable entity="VatType" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        {
          field: 'vatTypeOption',
          label: 'vat.vatTypeOption',
          formatter: this.formatVatTypeOption,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('vatType'),
            valueField: 'code',
            labelField: 'description'
          }
        },
        {
          field: 'vatNumberRequiredYN',
          label: 'vat.vatNumberRequiredYN',
          formatter: this.formatVatNumberRequiredYN,
          filter: {
            type: 'select',
            options: [
              { value: true, label: this.$t('common.yes') },
              { value: false, label: this.$t('common.no') }
            ],
            valueField: 'value',
            labelField: 'label'
          }
        },
        { field: 'taxCategoryCode', label: 'vat.taxCategoryCode' }
      ]
    };
  },
  methods: {
    formatVatTypeOption(row, column, value) {
      const option =
        value !== null && this.$store.getters['option/loadedOptions']('vatType').find(item => item.code === value);
      return option && option.description;
    },
    formatVatNumberRequiredYN(row, column, value) {
      if (value !== null && value) {
        return this.$t('common.yes');
      }
      return this.$t('common.no');
    },
    generateSummary({ vatTypeOption }) {
      return this.formatVatTypeOption(null, null, vatTypeOption);
    }
  }
};
</script>

<style scoped></style>
